module.exports = __webpack_public_path__ + "static/media/res5.7c814895.PNG";